module.exports = __webpack_public_path__ + "img/slide_1_comp_mob.c501c6f3.jpg";